import appUtils from '../../components/appUtils';

const minimized = appUtils.isSidebarMinimized();

export default {
  minimized
};
